import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetDetailWorkshop {
  message: string,
  result: detailWorkshop;
  success: boolean,
}

interface resGetAllTypeRegister {
  message: string,
  result: [
    {
      TYPE_ID: number,
      TYPE_NAME: string,
    }
  ];
  success: boolean,
}

interface resRegister {
  message: string,
  result: {
    createtime: Date,
  };
  success: boolean,
}

export interface resGetAllWorkshops {
  message: string,
  result: [
    {
      detailAllWorkshop
    }
  ];
  success: boolean,
}

interface detailAllWorkshop {
  WORKSHOP_PIC: string,
  WORKSHOP_ID: number,
  WORKSHOP_NAME: string,
  WORKSHOP_PLACE: string,
  WORKSHOP_COACH: string,
  WORKSHOP_COACH_PIC: string,
  WORKSHOP_PRICE: string,
  WORKSHOP_DETAIL: string,
  WORKSHOP_QTY_LEARNERS: number,
  WORKSHOP_STATUS: number,
  COUNT_REGIS: number,
  WORKSHOP_DATE: [
    {
      dateTime: [Date, Date]
    }
  ];
}

interface detailWorkshop {
  COUNT_REGIS: number,
  CREATE_DATE: Date,
  HAVE_LOGIN: boolean,
  REGISTED: boolean,
  UPDATE_DATE: Date,
  WORKSHOP_COACH: string,
  WORKSHOP_COACH_ORIGINAL: string,
  WORKSHOP_COACH_PIC: string,
  WORKSHOP_COACH_PICNAME: string,
  WORKSHOP_DATE: [
    {
      dateTime: [Date, Date];
    }
  ];
  WORKSHOP_DETAIL: string,
  WORKSHOP_DOC: [
    {
      DOC_ID: number,
      DOC_NAME: string,
      DOC_URL: string,
    }
  ];
  WORKSHOP_ID: string,
  WORKSHOP_NAME: string,
  WORKSHOP_PHONENUM: string,
  WORKSHOP_PIC: string,
  WORKSHOP_PICNAME: string,
  WORKSHOP_PIC_ORIGINAL: string,
  WORKSHOP_PLACE: string,
  WORKSHOP_PRICE: number,
  WORKSHOP_QTY_LEARNERS: number,
  WORKSHOP_STATUS: number,
}


interface resGetAllConsult {
  message: string,
  success: boolean,
  result: [{
    group: [{
      CONSULT_Instructor: [{
        USERNAME: string,
        USER_ID: string,
      }],
      LIST: [{
        Consult
      }]
    }],
    person: [{
      CONSULT_Instructor: [
        {
          USERNAME: string,
          USER_ID: string,
        }
      ],
      LIST: [{
        Consult
      }]
    }]
  }];
}

interface Consult {
  CONSULT_DATE: Date,
  CONSULT_STATUS: string,
  REGISTED: boolean,
  CONSULT_JOIN_TYPE: string,
  CONSULT_SOLUTION: string,
  MORE_DETAIL: string,
  STATUS_PAY: string,
  CONSULT_DETAIL: {
    CONSULT_DATE_END: Date,
    CONSULT_DATE_START: Date,
    CONSULT_ID: string,
    CONSULT_MAX: number,
    CONSULT_OBJECT: string,
    CONSULT_REGISTER: number,
    CONSULT_TYPE: string,
    CONSULT_UNIT_PRICE: number,
    CREATE_BY: string,
    CREATE_DATE: Date,
    UPDATE_BY: string,
    UPDATE_DATE: Date,
    USER_ID: string,
  }
}

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  token: string;

  constructor(private http: HttpClient, private authService: AuthService) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getDetailWorkshop(id) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetDetailWorkshop>(environment.URL + '/workshop/getDetailWorkShopById?WORKSHOP_ID=' + id, { headers: headers });
  }

  registerWorkshopById(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resRegister>(environment.URL + '/workshop/RegisterWorkShopById', body, { headers: headers });
  }

  getAllTypeRegister() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetAllTypeRegister>(environment.URL + '/workshop/getAllTypeRegister', { headers: headers });
  }

  getAllWorkshops() {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.get<resGetAllWorkshops>(environment.URL + '/workshop/getAllWorkShop', { headers: headers });
  }

  getAllConsultlistByExpertie(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resGetAllConsult>(environment.URL + '/consult/getAllConsultlistByExpertie', body, { headers: headers });
  }

  registerConsult(body) {
    const headers = new HttpHeaders({ Authorization: this.token });

    return this.http.post<resRegister>(environment.URL + '/consult/registerConsult', body, { headers: headers });
  }
}
